/**
* @constructor
* Implements a minimal disclosure element
*
* @param {Element} buttonNode The disclosure open button element.
*/

export default function Disclosure(buttonNode) {

	this.OpenButtonNode = buttonNode;
	this.disclosureElt = this.OpenButtonNode.parentNode.parentNode;
	this.closeButtonNode = this.disclosureElt.querySelector('.closeDisclosure');
	this.controlledNode = false;
	const id = this.OpenButtonNode.getAttribute('data-control');

	if (id) {
		this.controlledNode = document.getElementById(id);
	}

	this.showContent = () => {
		if (this.controlledNode) {
			this.controlledNode.classList.add('open');
			this.controlledNode.removeAttribute('aria-hidden');
		}
	};

	this.hideContent = () => {
		if (this.controlledNode) {
			this.controlledNode.classList.remove('open');
			this.controlledNode.setAttribute('aria-hidden', 'true');
		}
	};

	this.hideOpenedContent = (button) => {
		button.parentElement.classList.remove('expanded');
		button.setAttribute('aria-expanded', 'false');
		button.nextElementSibling.classList.remove('open');
		button.nextElementSibling.setAttribute('aria-hidden', 'true');
	}

	this.toggleExpand = () => {

		if (this.OpenButtonNode.getAttribute('aria-expanded') === 'true') {
			this.disclosureElt.classList.remove('expanded');
			this.OpenButtonNode.setAttribute('aria-expanded', 'false');
			this.hideContent();

			if (this.closeButtonNode) {
				this.closeButtonNode.setAttribute('aria-expanded', 'false');
				this.closeButtonNode.setAttribute('aria-hidden', 'true');
			}

		} else {

			this.disclosureElt.classList.add('expanded');
			this.OpenButtonNode.setAttribute('aria-expanded', 'true');
			this.showContent();

			if (this.closeButtonNode) {
				this.closeButtonNode.setAttribute('aria-expanded', 'true');
				this.closeButtonNode.removeAttribute('aria-hidden');
			}
		}
	};

	this.init = () => {
		// create button
		let text = this.OpenButtonNode.innerHTML;
		const button = document.createElement('button');
		button.setAttribute( "type", "button" );

		button.innerHTML = "<span>" + text + "</span>";
		this.OpenButtonNode.innerHTML = "";
		this.OpenButtonNode.appendChild(button);
		this.OpenButtonNode = button;

		this.OpenButtonNode.addEventListener('click', this.toggleExpand);
		this.OpenButtonNode.setAttribute('aria-expanded', 'false');
		this.OpenButtonNode.setAttribute('aria-control', id);
		this.controlledNode.setAttribute('aria-hidden', 'true');
		if (this.closeButtonNode) {
			this.closeButtonNode.addEventListener('click', this.toggleExpand);
		}
	};

}
